<script setup lang="ts">
import type { iconName } from "@/Modules/App/Models/Styles/Icons";

import TcIconButton from "@/Components/Extend/TcIconButton.vue";
import TcIcon from "@/Components/Extend/TcIcon.vue";
import { GContainer, GCol } from "@/Components/UI/Grid";

import { hasValue } from "@/Utils/Objects";

export interface ItemProps {
  title: string;
  date?: string | Date;
  icon?: iconName;
  isClickable?: boolean;
  isSending?: boolean;
}

const props = defineProps<ItemProps>();

const emit = defineEmits<{
  (e: "select"): void;
  (e: "send"): void;
}>();

const onClick = () => {
  if (props.isClickable) emit("select");
};
</script>

<template>
  <GContainer
    class="questionnaire"
    :class="{ 'questionnaire--clickable': isClickable }"
    @click="onClick"
    columns="1fr auto"
  >
    <GCol direction="column" align="start">
      <span class="questionnaire__title">{{ title }}</span>
      <span v-if="hasValue(date)" class="questionnaire__date">{{ date }}</span>
    </GCol>

    <GCol v-if="props.icon">
      <TcIcon v-if="props.isClickable" :name="props.icon" />
      <TcIconButton v-else :iconName="props.icon" :isLoading="isSending" @click="emit('send')" />
    </GCol>
  </GContainer>
</template>

<style scoped lang="scss">
.questionnaire {
  @include colors.bg(background, base);
  @include sp.padding(false, 3);
  @include radius(s);

  &__title {
    @include text.general(low, l);
    @include colors.color(content, high);
  }

  &__date {
    @include text.general(low, m);
    @include colors.color(content, mid-solid);
  }

  &--clickable {
    cursor: pointer;

    &:hover {
      @include colors.bg(secondary, low-solid, true);
      @include elevation(s);
    }
  }
}
</style>
